export default function extractTextFromQuery(query, param) {
  return query[param] || '';
}
